<template>
  <v-container class="bordered bg-white mb-4">
    <CalcInputSelect
      :id="nodeId"
      class="mb-4"
      field="location"
      :items="locations" />
    <CalcInputSelect
      :id="nodeId"
      class="mb-4"
      field="shift_model_part"
      :items="shiftModels" />
    <v-table
      v-if="
        variant.location &&
        variant.shift_model_part &&
        spaceStore.calculationElements[variant.shift_model_part]
      "
      class="table_variant_surcharge">
      <tbody>
        <tr>
          <td class="wide_col">
            {{
              $t(
                "entities.shiftModel.fields.staff_availability_after_deductions_shiftModel"
              )
            }}
          </td>
          <td class="input_col">
            <CalcOutput
              :id="variant.shift_model_part"
              hide-label
              field="staff_availability_after_deductions_shiftModel" />
          </td>
          <td class="e_per_piece_col">
            {{ $t("units.h_per_shift") }}
          </td>
        </tr>
        <tr>
          <td class="wide_col">
            {{
              $t(
                "entities.shiftModel.fields.machine_availability_after_deductions_shiftModel"
              )
            }}
          </td>
          <td class="input_col">
            <CalcOutput
              :id="variant.shift_model_part"
              field="machine_availability_after_deductions_shiftModel"
              hide-label />
          </td>
          <td class="e_per_piece_col">
            {{ $t("units.h_per_shift") }}
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-container>
</template>

<script setup>
import { computed } from "vue";
import CalcInputSelect from "@/components/Elements/CalcInputSelect.vue";
import { useSpaceStore } from "../../../../../stores/spaceStore";
import CalcOutput from "../../../../../components/Elements/CalcOutput.vue";
import { useTreeStore } from "@/stores/treeStore";

const spaceStore = useSpaceStore();
const treeStore = useTreeStore();

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  },
  variant: {
    type: Object,
    required: true
  }
});

const part = computed(() => {
  return spaceStore.getElement(props.nodeId);
});

const locations = computed(() => {
  const result = [];
  if (treeStore.elementLocation[part.value.parent]) {
    result.push({
      id: part.value.parent,
      name:
        "Eltern - " +
        spaceStore.getElement(treeStore.elementLocation[part.value.parent]).name
    });
  }

  return Object.entries(spaceStore.calculationElements)
    .reduce((result, [id, element]) => {
      if (id.endsWith("location")) {
        result.push(Object.assign({}, element, { id }));
      }
      return result;
    }, result)
    .map((location) => {
      return {
        value: location.id,
        title: location.name
      };
    });
});

const location = computed(() => {
  return treeStore.elementLocation[props.nodeId];
});

const shiftModels = computed(() => {
  return spaceStore
    .getElementList(location.value, "shiftModel")
    .map((shiftModel) => {
      return {
        value: shiftModel.fullId,
        title: shiftModel.name
      };
    });
});
</script>
